import React, { useEffect } from "react";
import "./Loading.css";
import {
  LoadingContainer,
  LoadingLogoWrapper,
  RotatingArc,
  CenterLogo,
  TextoCargando,
} from "./localstyle";
import Llama from "./assets/Llama.png";
import ObjNaranja from "./assets/ObjNaranja.png";

// Si el Loading está visible más de este tiempo, asumimos que hay un request
// colgado (red intermitente, promesa sin respuesta, etc.) y recargamos la app
// para evitar que la terminal quede trabada exigiendo intervención manual.
const TIEMPO_MAX_LOADING_MS = 20000;

const Loading = ({ dataLoading, color, descripcion, disableWatchdog }) => {
  useEffect(() => {
    if (!dataLoading || disableWatchdog) return;

    const watchdog = setTimeout(() => {
      console.warn(
        `[CheckinQR] Loading colgado >${TIEMPO_MAX_LOADING_MS / 1000}s — recargando la app`,
        { descripcion },
      );
      window.location.reload();
    }, TIEMPO_MAX_LOADING_MS);

    return () => clearTimeout(watchdog);
  }, [dataLoading, descripcion, disableWatchdog]);

  return (
    <React.Fragment>
      {dataLoading && (
        <LoadingContainer>
          <LoadingLogoWrapper $texto={descripcion}>
            <RotatingArc>
              <img src={ObjNaranja} alt="" />
            </RotatingArc>
            <CenterLogo src={Llama} alt="Logo" />
          </LoadingLogoWrapper>
          <TextoCargando className="rb18m">{descripcion}</TextoCargando>
        </LoadingContainer>
      )}
    </React.Fragment>
  );
};

export default Loading;
